import React, { useEffect } from 'react';
import Carousel from 'react-material-ui-carousel'
import Image from './img/Engaging-an-AC-Compressor-Clutch.jpg'
import {makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Divider from '@material-ui/core/Divider';
import Power from './img/electric.jpg';
import Power1 from './img/power.jpg';
import Grid from '@material-ui/core/Grid';
import { Parallax } from "react-parallax";
import Para1 from './img/slider/donate.jpg';
import Scanner from './img/slider/scanner.png';
import Para2 from './img/slide2.jpeg';
import Para3 from './img/img/loader3.jpg';
import AOS from 'aos';
import "aos/dist/aos.css";
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { colors } from './sharedStyles';

const useStyles = makeStyles((theme) => ({
  heroSection: {
    position: 'relative',
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    overflow: 'hidden',
  },
  heroOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `rgba(44, 62, 80, 0)`,
    zIndex: 1,
  },
  heroContent: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: colors.white,
    maxWidth: 800,
    padding: '0 20px',
  },
  heroTitle: {
    fontSize: '3.5rem',
    fontWeight: 700,
    marginBottom: '1rem',
    textShadow: '2px 2px 4px rgba(0,0,0,0.5)',
    [theme.breakpoints.down('md')]: {
      fontSize: '2.5rem',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
  },
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '0 20px',
  },
  sectionTitle: {
    fontSize: '2.5rem',
    fontWeight: 700,
    textAlign: 'center',
    marginBottom: '3rem',
    color: colors.dark,
    position: 'relative',
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: '-10px',
      left: '50%',
      transform: 'translateX(-50%)',
      width: 60,
      height: 4,
      background: `linear-gradient(45deg, ${colors.primary}, ${colors.secondary})`,
      borderRadius: 2,
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '2rem',
    },
  },
  lightSection: {
    background: `linear-gradient(135deg, rgba(232, 244, 253, 0.6) 0%, rgba(209, 233, 251, 0.5) 100%)`,
    padding: '80px 0',
  },
  darkSection: {
    background: `linear-gradient(135deg, rgba(97, 218, 251, 0.3) 0%, rgba(74, 144, 226, 0.2) 50%, rgba(44, 62, 80, 0.1) 100%)`,
    padding: '80px 0',
    color: colors.white,
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: 16,
    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
    transition: 'all 0.3s ease',
    overflow: 'hidden',
    '&:hover': {
      transform: 'translateY(-8px)',
      boxShadow: '0 12px 40px rgba(0,0,0,0.15)',
    },
  },
  cardContent: {
    flexGrow: 1,
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardTitle: {
    fontSize: '1.5rem',
    fontWeight: 600,
    marginBottom: '1rem',
    color: colors.dark,
  },
  cardText: {
    color: colors.text,
    lineHeight: 1.6,
    flexGrow: 1,
  },
  donateButton: {
    background: `linear-gradient(45deg, ${colors.primary} 30%, ${colors.secondary} 90%)`,
    borderRadius: 16,
    padding: '20px',
    textAlign: 'center',
    color: colors.dark,
    textDecoration: 'none',
    display: 'block',
    transition: 'all 0.3s ease',
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    fontSize: '1.1rem',
    '&:hover': {
      transform: 'scale(1.02)',
      textDecoration: 'none',
      color: colors.dark,
      boxShadow: `0 8px 32px rgba(97, 218, 251, 0.4)`,
    },
  },
  donateText: {
    fontSize: '2rem',
    fontWeight: 700,
    margin: 0,
  },
  qrCode: {
    width: 200,
    height: 200,
    margin: '20px auto',
    display: 'block',
    borderRadius: 12,
    boxShadow: `0 4px 20px rgba(97, 218, 251, 0.2)`,
  },
}));

function Example(props) {
  const classes = useStyles();
  
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      offset: 100
    });
  }, []);
  
  var items = [
    {
      name: <h1 style={{color: colors.white, fontSize: "3.5rem", marginTop: 0, fontWeight: 700}} data-aos={"fade-up"}>
        <span style={{ padding: 12, backgroundColor: `rgba(44, 62, 80, 0.8)`, borderRadius: 8, textShadow: '2px 2px 4px rgba(0,0,0,0.5)', border: '2px solid rgba(97, 218, 251, 0.3)'}}>
          Support The Mission
        </span>
      </h1>,
      image: Para1,
      description: ""
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <Carousel swipe={true} indicators={false} touch={true} animation={"slide"} interval={5000}>
        {items.map((item, i) => <Item key={i} item={item} />)}
      </Carousel>

      {/* Donation Options Section */}
      <section className={classes.lightSection}>
        <div className={classes.container}>
          <Typography variant="h2" className={classes.sectionTitle} data-aos="fade-up">
            Support Our Mission
          </Typography>
          
          <Typography variant="h5" style={{textAlign: 'center', marginBottom: '3rem', color: colors.text, fontWeight: 300}} data-aos="fade-up">
            Your generous donations help us spread the 3 Angels Message and serve communities worldwide
          </Typography>

          <Grid container spacing={4}>
            <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay="100">
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  <Typography variant="h4" className={classes.cardTitle}>
                    💳 PayPal Donation
                  </Typography>
                  <Typography variant="body1" className={classes.cardText} style={{marginBottom: '2rem'}}>
                    Make a secure donation through PayPal. Your contribution will directly support our mission work and community outreach programs.
                  </Typography>
                  <a
                    href="https://www.paypal.com/donate?hosted_button_id=GWSM4SFC5S3K2&source=qr"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={classes.donateButton}
                    style={{ textDecoration: 'none', display: 'inline-block' }}
                  >
                    Donate with PayPal
                  </a>
                </CardContent>
              </Card>
            </Grid>

            <Grid item xs={12} md={6} data-aos="fade-up" data-aos-delay="200">
              <Card className={classes.card}>
                <CardContent className={classes.cardContent}>
                  <Typography variant="h4" className={classes.cardTitle}>
                    📱 PayPal QR Code
                  </Typography>
                  <Typography variant="body1" className={classes.cardText} style={{marginBottom: '2rem'}}>
                    Scan this QR code with your PayPal app to make a quick and secure donation. This QR code links directly to our PayPal donation page.
                  </Typography>
                  <img src={Scanner} alt="PayPal QR Code" className={classes.qrCode} />
                  <Typography variant="body2" style={{textAlign: 'center', color: colors.textLight}}>
                    Scan QR code to donate via PayPal
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </div>
      </section>

     

      {/* Why Donate Section */}
      <section style={{padding: '80px 0', background: colors.white}}>
        <div className={classes.container}>
          <Typography variant="h2" className={classes.sectionTitle} data-aos="fade-up">
            Why Donate?
          </Typography>
          
          <Typography variant="body1" style={{lineHeight: 1.8, color: colors.text, fontSize: '1.1rem', textAlign: 'center', maxWidth: 800, margin: '0 auto 3rem'}} data-aos="fade-up">
            Your donations directly support our mission to spread the 3 Angels Message and serve communities worldwide. 
            Every contribution helps us provide essential services, education, and spiritual guidance to those in need.
          </Typography>
        </div>
      </section>
    </div>
  );
}

function Item(props) {
  const classes = useStyles();
  return (
    <div 
      className={classes.heroSection} 
      style={{
        backgroundImage: `linear-gradient(rgba(44, 62, 80, 0.7), rgba(44, 62, 80, 0.7)), url(${props.item.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className={classes.heroOverlay}></div>
      <div className={classes.heroContent}>
        {props.item.name}
        <Typography variant="h4" style={{color: colors.white, fontSize: '1.2rem', marginTop: '1rem'}} data-aos="fade-up">
          {props.item.description}
        </Typography>
      </div>
    </div>
  );
}

export default Example;


